module.exports = __webpack_public_path__ + "static/img/yinpinshouquan.98d679b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/yinpinshouquan.png
// module id = vCm4
// module chunks = 31